export default function customAccordions() {
  const accordions = document.querySelectorAll(".custom-accordions");

  if (!accordions.length) return;

  accordions.forEach((acc) => {
    const items = acc.querySelectorAll(".item");

    items.forEach((item) => {
      const panel = item.querySelector(".panel");
      const content = item.querySelector(".content");

      // initial state
      content.style.height = "0px";

      panel.addEventListener("click", () => {
        const isActive = item.classList.contains("active");

        // close all (single open)
        items.forEach((i) => {
          i.classList.remove("active");
          i.querySelector(".content").style.height = "0px";
        });

        // open current
        if (!isActive) {
          item.classList.add("active");
          content.style.height = content.scrollHeight + "px";
        }
      });
    });
  });
}